import React, { useMemo } from "react";
import { Row, Col, Card } from "antd";
import { StyledFeaturesSection } from "./styles";

const FeaturesSection = () => {
  const features = useMemo(
    () => [
      {
        icon: <span>💬</span>,
        iconColor: "orange",
        bgColor: "blue",
        title: "Customer Conversations",
        subTitle: "Connect with every customer in one place.",
        description:
          "Smart reply suggestions, automatic reminders, and conversation summaries help your team respond faster.",
      },
      {
        icon: <span>👥</span>,
        iconColor: "cyan",
        bgColor: "pink",
        title: "Team Collaboration",
        subTitle: "Work together in real time.",
        description:
          "Collaborate behind the scenes without leaving the customer conversation.",
      },
      {
        icon: <span>📹</span>,
        iconColor: "green",
        bgColor: "green",
        title: "Video Meetings",
        subTitle: "Meet without switching apps.",
        description:
          "Start secure video meetings directly from any conversation.",
      },
      {
        icon: <span>📋</span>,
        iconColor: "blue",
        bgColor: "yellow",
        title: "Tasks & Documents",
        subTitle: "Turn conversations into organised work.",
        description:
          "Create tasks, share documents and keep every customer journey on track.",
      },
      {
        icon: <span>🌐</span>,
        iconColor: "purple",
        bgColor: "purple",
        title: "Customer Portal",
        subTitle: "Keep customers informed in one secure place.",
        description:
          "Share updates, documents and messages through a dedicated portal.",
      },

      {
        icon: <span>🤖</span>,
        iconColor: "purple",
        bgColor: "orange",
        title: "AI Agents",
        subTitle: "Automate work with AI that knows your business.",
        description:
          "Handle repetitive work, assist your team and power smarter customer experiences.",
      },
    ],
    [],
  );

  return (
    <StyledFeaturesSection className="section-padding flex-col" id="features">
      <span className="section-label">Core capabilities</span>
      <h2 className="section-title">
        Everything you need to manage customer relationships.
      </h2>
      <h5 className="section-sub-title">
        Six connected capabilities. One consistent experience for your team and
        every customer you serve.
      </h5>

      <div className="features-container">
        <Row className="features-row" gutter={[24, 24]}>
          {features.map((feature, index) => (
            <Col key={index} xs={24} sm={12} lg={8} className="feature-col">
              <Card className="feature-card" bordered={false}>
                <div className={`icon-wrapper rounded ${feature.bgColor}-bg`}>
                  <span className={`feature-icon ${feature.iconColor}-icon`}>
                    {feature.icon}
                  </span>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <h3 className="feature-sub-title">{feature.subTitle}</h3>
                {feature.description && (
                  <p className="feature-description">{feature.description}</p>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </StyledFeaturesSection>
  );
};

export default FeaturesSection;
